import { Injectable, Injector } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { EventResponseDTO } from '../models/event/responses/EventResponseDTO';
import { BaseAPIService } from './base.service';
import { ResultSegmentDTO } from '../models/common/ResultSegmentDTO';

@Injectable({
    providedIn: "root"
})
export class EventAPIService  extends BaseAPIService {

    constructor(injector: Injector) {
        super(injector);
    }

    private getEventsSegment(segment_index: number|undefined, query_token: string|undefined): Observable<ResultSegmentDTO<EventResponseDTO>> {
        let params = new HttpParams();
        params = params.append("publisher_code", "IB");
        if(segment_index !== undefined) params = params.append('segment_index', segment_index.toString());
        if(query_token) params = params.append('query_token', query_token);
        return this.httpGet<ResultSegmentDTO<EventResponseDTO>>(`/events`, { params });
    }

    public getEvents(): Observable<EventResponseDTO[]> {
        return this.getAllSegments<EventResponseDTO>(this.getEventsSegment.bind(this));
    }

    getEventDetails(id:string): Observable<EventResponseDTO> {
        let params = new HttpParams();
        params = params.append("publisher_code", "IB");
        return this.httpGet<EventResponseDTO>(`/events/${id}`, { params });
    }
}